import { render, staticRenderFns } from "./PprNoPopup.vue?vue&type=template&id=b568c63c&"
import script from "./PprNoPopup.vue?vue&type=script&lang=js&"
export * from "./PprNoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports